import Banner from './styled';

export default Banner;
